export const DATE_FORMAT = "DD.MM.YYYY";
export const RES_DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_TIME = "DD.MM.YYYY HH:mm";
